import React from 'react'
import { usePublicLinks } from 'hooks'
import { SiteLogo, Sidebar } from 'components'
import StaticPage from '../Static/StaticPage'
import StyledHeader from 'components/Header/StyledHeader'
import StyledGuestApp from './StyledGuestApp'

const GuestApp = () => {
  const links = [{ to: '/', label: 'sections/home', exact: true }, ...usePublicLinks()]
  return (
    <StyledGuestApp>
      <Sidebar routes={links} />
      <main>
        <StyledHeader>
          <SiteLogo />
        </StyledHeader>
        <div className="content">
          <StaticPage />
        </div>
      </main>
    </StyledGuestApp>
  )
}

export default GuestApp
